// src/widget-entry.cart.ts
import type { WidgetProps } from './runtime/widgetConfig'
import { setWidgetConfig } from './runtime/widgetConfig'
import { loadCartWidget } from './bootstrap/loadCartWidget'
import './style.css'

type PublicCreateOptions = WidgetProps & { mount: string | Element }

export async function create(opts: PublicCreateOptions) {
    if (!opts) throw new Error('PixelCartWidget.create: options missing')

    const { mount, ...props } = opts

    const mountEl = typeof mount === 'string' ? document.querySelector(mount) : mount
    if (!mountEl) throw new Error(`PixelCartWidget.create: mount target not found (${String(mount)})`)

    // ✅ Critical: cart store + services rely on getWidgetConfig() -> set it here
    setWidgetConfig(props)

    return loadCartWidget({ mountEl, props })
}

/** optional alias */
export const mountWidget = create
